import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageState } from '@core/localization/language.state';
import { InvoiceService } from '@api/services/invoice.service';
import { map } from 'rxjs/operators';
import { AvailableLanguage } from '@core/localization/available-language';
import { Observable } from 'rxjs';
import { LocalStorage } from '@core/storage/local-storage';
import { StorageKeys } from '@core/storage/storage.keys';
import { ListB2BInvoiceResponse } from '@api/models/B2bService/Contract/Invoice/list-b-2-b-invoice-response';


@Pipe({
    name: 'urlInvoice',
    standalone: true,
})
export class UrlInvoicePipe implements PipeTransform {
    @LocalStorage(StorageKeys.Access)
    protected token: string;

    readonly #languageState: LanguageState = inject(LanguageState);

    public transform(invoice: ListB2BInvoiceResponse): Observable<string> {
        return this.#languageState.language$.pipe(
            map((language: AvailableLanguage) =>
                InvoiceService.ApiB2BGetB2BInvoicePdfGetPath + '?' +
                'lang=' + language + '&' +
                'invId=' + String(invoice.invId) + '&' +
                'token=' + this.token),
        );
    }
}
